<template>
  <div>
    <transition name="modal">
      <div class="modal-mask modal-mask-height">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content yesNoPad">
              <div class="mt-2 mb-4">
                <h4 class="modal-title text-center"> {{ msg }}</h4>
              </div>

              <div class="col-12 text-center ">
                <div class="m-btn-wrap mr-t20">
                  <button
                    type="submit"
                    data-toggle="modal"
                    data-target="#requestModal"
                    class="rdBtn btnst getFont"
                    @click="sendResponse(true)"
                  >
                    Yes
                  </button>
                  <button
                    id="2"
                    data-dismiss="modal"
                    class="whtBtn btnst cursor-pointer getFont"
                    @click="sendResponse(false)"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: { msg: String },
  emits: ['response'],
  methods: {
    sendResponse(val) {
      this.$emit('response', val)
    },
  },
}
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header {
  border-bottom: none;
}

.getFontBold {
  font-family: JosefinSans-Bold;
  font-size: 14px;
}

.whtBtn {
  background-color: white;
  border: 1px solid black;
}

.rdBtn {
  margin-right: 12px;
  background-color: #d13851 !important;
  color: white !important;
  box-shadow: none;
  border: 1px solid #d13851;
}

.btnst {
  padding: 11px;
  padding-left: 33px;
  padding-right: 33px;
}
.yesNoPad {
  padding: 50px !important;
}
@media (max-width: 576px) {
  .yesNoPad {
    /* padding: 23px !important; */
    padding: 15px !important;
  }
}
</style>
